import React from "react";
import * as SurveyReact from "survey-react-ui";
import { ReactQuestionFactory } from "survey-react-ui";
import GlBoolean from "./GlBoolean";

class GlBooleanQuestion extends SurveyReact.SurveyQuestionBoolean {
  renderElement() {
    return (
      <GlBoolean question={this.question} isReadOnly={this.isDisplayMode} />
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion("boolean", (props) =>
  React.createElement(GlBooleanQuestion, props)
);

export {};
